import block from "./block.js";
import component from "./components/index.js"
import containerStatistics from "./components/containerStatistics.js";

export default (editor, opts = {}) => {
    //components
  editor.DomComponents.addType("containerStatistics", containerStatistics(opts));
  editor.DomComponents.addType("statistics1", component(opts));
    //block
  editor.BlockManager.add("statistics1", block(opts));
};